/* "Read more" on the science cards (sections/reformly-bp-science.liquid).

   Phone only, and the CSS enforces that — the button is display:none above 900
   where the card shows its copy in full. This just flips the state; the height
   animation is grid-template-rows 0fr -> 1fr in the stylesheet.

   No listener per card: one delegated handler, so cards added by the theme
   editor work without re-binding. */
(function () {
  'use strict';

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-rbp-sci-more]');
    if (!btn) return;

    var open = btn.getAttribute('aria-expanded') === 'true';
    btn.setAttribute('aria-expanded', open ? 'false' : 'true');

    var card = btn.closest('.rbp-sci__card');
    if (card) card.classList.toggle('is-open', !open);

    var label = btn.querySelector('[data-rbp-sci-more-label]');
    if (label) label.textContent = open ? btn.dataset.more : btn.dataset.less;
  });
})();
